import _ from "lodash";
import React, { Component, Suspense, lazy } from "react";
import { connect } from "react-redux";
import LocaleStrings from "Languages";
import { Field, reduxForm, reset } from "redux-form";
import Button from "react-bootstrap-button-loader";
import { IMAGE_PATH, COMMON_FAIL_MESSAGE, validateEmail } from "Constants";
import { showError, showSuccess } from "ReduxErrorBar";
import { BaseComponent } from "BaseComponent";

import { checkEventTemplate } from "TemplatesAction";

import Templates from "../wizard/theme-templates";
import {
  fetchTemplatesWizardStep,
  saveTemplatesWizardData,
  redeployFunction,
  fetchSiteDetails,
  initialCheckAtThemeFunc,
} from "../../actions";

// const AsyncTemplates = lazy(() => import('./theme-templates'));

class Theme extends BaseComponent {
  constructor(props) {
    super(props);
    this.onSubmitForm = this.onSubmitForm.bind(this);
    this.state = { loading: false };
  }

  componentDidMount() {
    this.props.checkEventTemplate(this.props.session);

    this.props.fetchSiteDetails(this.props.session);
    this.props.initialCheckAtThemeFunc(true);
  }

  onSubmitForm(values) {
    // // this.setState({ loading: true });


    // let { TemplatesWizardData, templateThemeData, eventSelectedTemplate, optionStateTheme } = this.props;


    // // let data = TemplatesWizardData;

    // // Assigning value using this code showing error : "Uncaught TypeError: Cannot set property 'selectedtemplate' of undefined (at handleSunmit)"
    // // data.resource.theme.selectedtemplate = templateThemeData && !_.isEmpty(templateThemeData)? templateThemeData : undefined ;
    // // data.resource.theme.eventSelectedTemplate = eventSelectedTemplate;

    // //Assigning value in this way works perfect
    // // data.resource.theme = {
    // //     newSelectedtemplate: templateThemeData,
    // //     eventSelectedTemplate: eventSelectedTemplate,
    // // };

    // // data.resource.theme = {
    // //     selectedtemplate: optionStateTheme,

    // // };

    // // this.props.saveTemplatesWizardData(data);

    // setTimeout(() => {

    //     // this.props.fetchTemplatesWizardStep('step_4');
    // }, 1);

    let { optionStateTheme } = this.props;
    let redeployData = optionStateTheme;

    this.props.redeployFunction({
      redeploy: true,
      from: "theme",
      data: redeployData,
    });



    setTimeout(() => {

      this.redirectToWizard();
    }, 100);
  }

  redirectToWizard = () => {


    var path = "wizard";
    this.props.history.push(`/dashboard/website/${path}`);
  };

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      editMode,
      initialValues,
      TemplatesWizardStep,
      TemplatesWizardData,
      templateThemeData,
      eventSelectedTemplate,
      optionStateTheme,
      siteDetails,
      deviceSize,
    } = this.props;

    let disabled = true;
    if (
      optionStateTheme &&
      !_.isEmpty(optionStateTheme) &&
      siteDetails &&
      siteDetails.resource &&
      !_.isEmpty(siteDetails.resource) &&
      siteDetails.resource[0].templateid != optionStateTheme.id
    ) {
      disabled = false;
    }

   

    return (
      <div
        className="panel-body scrollable-content"
        // style={{ height: deviceSize.height - 70 }}
      >
        <form onSubmit={handleSubmit(this.onSubmitForm)}>
          <div className="row">
            <div className="col-md-12">
              <label className="heading-theme-text-color">
                Themes for your website
              </label>

              <div
                className="col-md-12 p-15"
                style={{
                  border: "solid 1px #A9ABB5",
                  borderRadius: 10,
                }}
              >
                <Templates callfrom="wizard" />
                {/* <Suspense fallback={<h3>Loading...</h3>}>
                  <AsyncTemplates callfrom="wizard" />
                </Suspense> */}

                <div className="col-md-12 text-center">
                  <Button
                    className="btn-custom-blue mt-70 mb-10"
                    loading={this.state.loading}
                    disabled={disabled}
                    type="submit"
                  >
                    Update Theme And Re-Deploy
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

function validate(values) {
  var errors = {};

  return errors;
}

function mapStateToProps(state) {
  var initVals = null;
  var toEdit = false;

  return {
    session: state.session,
    initialValues: initVals,
    editMode: toEdit,
    TemplatesWizardStep: state.TemplatesWizardStep,
    TemplatesWizardData: state.TemplatesWizardData,
    templateThemeData: state.templateThemeData,
    eventSelectedTemplate: state.eventSelectedTemplate,
    optionStateTheme: state.optionStateTheme,
    siteDetails: state.siteDetails,
    redeploy: state.redeploy,
    initialCheckAtTheme: state.initialCheckAtTheme,
    deviceSize: state.deviceSize,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  fetchTemplatesWizardStep,
  saveTemplatesWizardData,
  checkEventTemplate,
  redeployFunction,
  fetchSiteDetails,
  initialCheckAtThemeFunc,
})(
  reduxForm({
    validate,
    form: "TemplatesThemeForm",
    enableReinitialize: true,
    // keepDirtyOnReinitialize: true
  })(Theme)
);
